<template>
  <div class="box-change">
    <div class="box-title">
      <div class="text">Đổi Mật Khẩu</div>
    </div>
    <div class="content-box">
      <div class="warning-text warning-changepass">
        Bạn Sẽ Phải Đăng Nhập Lại Sau Khi Đổi Mật Khẩu Thành Công
      </div>
      <b-form @submit.prevent="onUpdatePassword">
        <div class="form-group">
          <label for="User_Password">Mật khẩu hiện tại</label>
          <b-input-group class="">
            <template #prepend>
              <b-input-group-text class="p-0">
                <b-button variant="info" @click="show1 = !show1">
                  <i :class="[show1 ? 'bx-show-alt' : 'bx-hide', 'bx']"></i>
                </b-button>
              </b-input-group-text>
            </template>
            <b-form-input
              :type="show1 ? 'text' : 'password'"
              required
              id="User_Password"
              v-model.trim="change.User_Password"
              placeholder="Nhập Mật khẩu hiện tại"
              :class="{
                'is-invalid': submitted && $v.change.User_Password.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.change.User_Password.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.change.User_Password.required">
                {{ $t("auth.required-password") }}
              </span>
            </div>
          </b-input-group>
        </div>
        <div class="form-group">
          <label for="User_New_Password ">Mật khẩu mới</label>
          <b-input-group class="">
            <template #prepend>
              <b-input-group-text class="p-0">
                <b-button variant="info" @click="show2 = !show2">
                  <i :class="[show2 ? 'bx-show-alt' : 'bx-hide', 'bx']"></i>
                </b-button>
              </b-input-group-text>
            </template>
            <b-form-input
              id="User_New_Password "
              v-model.trim="change.User_New_Password"
              :type="show2 ? 'text' : 'password'"
              placeholder="Nhập mật khẩu mới"
              :class="{
                'is-invalid': submitted && $v.change.User_New_Password.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.change.User_New_Password.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.change.User_New_Password.required">
                {{ $t("auth.required-password") }}
              </span>
              <span v-if="!$v.change.User_New_Password.minLength">
                {{ $t("auth.min-length") }}
              </span>
              <span v-if="!$v.change.User_New_Password.notSameAsPassword">
                Mật khẩu mới không được giống mật khẩu cũ
              </span>
            </div>
          </b-input-group>
        </div>
        <div class="form-group">
          <label for="User_Re_New_Password ">Nhập lại mật khẩu mới</label>
          <b-input-group class="">
            <template #prepend>
              <b-input-group-text class="p-0">
                <b-button variant="info" @click="show3 = !show3">
                  <i :class="[show3 ? 'bx-show-alt' : 'bx-hide', 'bx']"></i>
                </b-button>
              </b-input-group-text>
            </template>
            <b-form-input
              :type="show3 ? 'text' : 'password'"
              required
              id="User_Re_New_Password "
              v-model.trim="change.User_Re_New_Password"
              placeholder="Nhập lại mật khẩu mới"
              :class="{
                'is-invalid':
                  submitted && $v.change.User_Re_New_Password.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && !$v.change.User_Re_New_Password.required"
              class="invalid-feedback"
            >
              {{ $t("auth.required-re-password") }}
            </div>
            <div
              v-if="submitted && !$v.change.User_Re_New_Password.sameAsPassword"
              class="invalid-feedback"
            >
              {{ $t("auth.sameAsPassword") }}
            </div>
          </b-input-group>
        </div>
        <div class="form-group d-flex justify-content-center">
          <b-button class="mx-auto mt-3" variant="primary" type="submit">
            Đổi Mật Khẩu
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required, sameAs, minLength, not } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      change: {
        User_Password: "",
        User_New_Password: "",
        User_Re_New_Password: "",
      },
      show1: false,
      show2: false,
      show3: false,
      submitted: false,
    };
  },
  validations: {
    change: {
      User_Password: {
        required,
      },
      User_New_Password: {
        required,
        minLength: minLength(8),
        notSameAsPassword: not(sameAs("User_Password")),
      },
      User_Re_New_Password: {
        required,
        sameAsPassword: sameAs("User_New_Password"),
      },
    },
  },
  methods: {
    onUpdatePassword() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      if (this.change.User_Password === this.change.User_New_Password) {
        this.$toastr.e("Mật mới phải khác mật khẩu cũ");
        return;
      }
      if (this.change.User_Re_New_Password !== this.change.User_New_Password) {
        this.$toastr.e("Nhập lại mật khẩu phải giống với mật khẩu mới");
        return;
      }
      this.$store.dispatch("user/req_postChangePassword", {
        current_password: this.change.User_Password,
        new_password: this.change.User_New_Password,
      });
    },
  },
};
</script>

<style lang="scss">
.box-change {
  width: 100%;
  min-height: 50px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.25rem;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 1.25rem;
    background-color: #ffff;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.305);
    .text {
      color: #000;
      font-weight: 600;
      font-size: 20px;
      text-transform: capitalize;
      .text-warning {
        font-size: clamp(15px, 2vw, 16px);
      }
    }
    .icon {
      cursor: pointer;
      img {
        height: 20px;
        width: auto;
      }
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .content-box {
    padding: 1.25rem;
    .warning-changepass {
      font-weight: 700;
      color: darkorange;
      font-size: clamp(15px, 2.5vw, 16.2px);
      margin-bottom: 15px;
      text-transform: capitalize;
      text-align: center;
    }
    .form-group {
      max-width: 690px;
      margin: 0 auto 10px;
      label {
        font-weight: 600;
        color: #ffff;
        font-size: 16px;
        margin-top: 15px;
      }
      .input-group-text {
        background: transparent;
        padding: 0;
        border: 1px solid #e9ecef;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      input {
        width: 1 1 auto;
        border: 1px solid #e9ecef;
        height: 40px;
        font-size: clamp(13px, 1vw, 14.2px);
        font-weight: 600;
        background: #fff;
        border-radius: 5px;
        padding-left: 5px;
        color: #000 !important;
        &:focus {
          box-shadow: 0 0 0 1px rgba(56, 169, 73, 45%);
        }
        &::placeholder {
          font-weight: 500;
          font-size: clamp(13px, 1vw, 15px);
        }
      }
    }
  }
}
</style>
